import get from 'lodash/get';

export const cachedDispatch = state => get(state, '_cache_.dispatch', null);
export const removeFromCache = state => get(state, '_cache_.delete', null);
export const clearCache = state => {
    const cache = get(state, '_cache_', null);
    if (!cache) return null;
    return cache.clear.bind(cache);
};
